import React, { useMemo } from 'react';
import { defineMessages } from 'react-intl';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFormField from '@hooks/useFormField';
import useTranslate from '@hooks/useTranslate';
import { Form, Upload } from 'antd';
import ImgCrop from 'antd-img-crop';

import styles from './index.module.scss';

const message = defineMessages({
    upload: '{loading, select, true {uploading} other {upload}}',
});

function CropImageFieldNoCrop({
    label,
    fileList,
    disabled,
    name,
    valuePropName,
    accept,
    onChange,
    beforeUpload,
    aspect = 1,
    maxFile,
    imageUrl,
    loading,
    style,
    required,
    formItemProps,
    imgUploadedSizeAuto,
    ...props
}) {
    const { rules } = useFormField({ required, ...props });
    const translate = useTranslate();

    const onUploadFile = ({ file, onSuccess, onError }) => {
        const { uploadFile } = props;
        uploadFile(file, onSuccess, onError);
    };

    const getContent = () => {
        if (imageUrl && !loading) {
            return (
                <div style={{ margin: 4 }}>
                    <img
                        style={{ maxWidth: '100%', objectFit: 'contain', backgroundColor: '#000' }}
                        className="img-uploaded"
                        src={imageUrl}
                        alt="field-upload"
                    />
                </div>
            );
        } else {
            return renderUploadButton();
        }
    };

    const renderUploadButton = () => {
        return (
            <div className="upload-wrapper">
                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div className="ant-upload-text">{translate.formatMessage(message.upload, { loading })}</div>
            </div>
        );
    };

    const uploadClass = useMemo(() => {
        return [ 'avatar-uploader', imgUploadedSizeAuto && 'img-uploaded-size-auto' ].filter(Boolean).join(' ');
    }, []);

    return (
        <Form.Item
            {...formItemProps}
            required={required}
            label={label}
            name={name}
            rules={rules}
            valuePropName={valuePropName}
            validateTrigger="onSubmit"
            help={null}
        >
            <Upload
                disabled={disabled}
                accept={accept}
                valuePropName={valuePropName}
                listType="picture-card"
                style={{ width: '100%' }}
                showUploadList={false}
                customRequest={onUploadFile}
                beforeUpload={beforeUpload}
                onChange={onChange}
                className={uploadClass}
            >
                {getContent()}
            </Upload>
        </Form.Item>
    );
}

export default CropImageFieldNoCrop;
